// useClipboard.ts — 剪贴板写入，带 HTTP 明文环境降级 (Round 12)
//
// navigator.clipboard 仅在 Secure Context (https / localhost) 下存在。
// AFD 控制台常部署为 http://<内网IP>:8080 — 此时 clipboard 为 undefined，
// 直接调用会 TypeError。这里提供统一入口：
//   1. navigator.clipboard 可用 (安全上下文) → 原生 API
//   2. 否则 → 隐藏 textarea + document.execCommand('copy') 降级
//      (execCommand 虽被标记 deprecated, 但在明文 HTTP 下是唯一手段,
//       Chrome/Edge/Firefox 至今仍然支持)

function legacyCopy(text: string): boolean {
  const ta = document.createElement('textarea')
  ta.value = text
  ta.setAttribute('readonly', '')
  ta.style.position = 'fixed'
  ta.style.top = '-1000px'
  ta.style.opacity = '0'
  document.body.appendChild(ta)
  ta.focus()
  ta.select()
  ta.setSelectionRange(0, text.length)
  let ok = false
  try {
    ok = document.execCommand('copy')
  } catch {
    ok = false
  }
  document.body.removeChild(ta)
  return ok
}

/** 复制文本到剪贴板，返回是否成功（不弹 toast，由调用方决定提示方式）。 */
export async function copyToClipboard(text: string): Promise<boolean> {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      // fall through to legacy
    }
  }
  return legacyCopy(text)
}
